import React, {Fragment} from "react";
import TextInput from "../../../TextInput";
import Select from "../../../Select";
import XLSX from "xlsx";
import Papa from "papaparse/papaparse";
import Tabs from "../../../../layout/Tabs";
import TabContent from "../../../../layout/TabContent";
import {set} from "../../../../../utils/dotutils";
import ImportButton from "../../../ImportButton";
import Field from "../Field";
import Icon from "../../../Icon";
import Confirm from "../../../Confirm";
import {GUIProps} from "../Table/Types/GUIProps";
import isEqual from "lodash-es/isEqual";
import {fileUpload, postData} from "../../../../../utils/request";
import ContentLoader from "../../../../layout/ContentLoader";
import DataGridInternal from "../DataGridInternal";
import FieldData from "../Table/FieldData";

// https://stackoverflow.com/a/46175899/1149311
const nextChar = c=>c?String.fromCharCode(c.charCodeAt(0)+1):'A';
const nextCol = s=>s.replace(/([^Z]?)(Z*)$/, (_,a,z)=>nextChar(a) + z.replace(/Z/g,'A'));

class TXT {
    static build(data, _import) {
        return new Promise(resolve => {
            let rows = data.split(/\r?\n/);
            const columns = _import?.config?.column_widths || [];
            rows = rows.map((row) => {
                let data = [];
                let current = 0;
                columns.map((column) => {
                    data.push(row.slice(current, current + column));
                    current += column;
                });
                return data;
            });
            console.log(rows);
            resolve({
                meta: {},
                data: rows
            });
        });
    }
    static parse(file) {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsText(file);
        });
    }
    static parameters(props) {
        return null;
    }
}


class CSV {
    static build(data, _import) {
        return new Promise(resolve => {
            Papa.parse(data, {
                quoteChar: _import?.config?.enclosure,
                escapeChar: _import?.config?.escape,
                delimiter: _import?.config?.delimiter,
                newline: _import?.config?.linebreak,
                complete: (results) => {
                    resolve({
                        meta: {
                            delimiter: results.meta.delimiter,
                            linebreak: results.meta.linebreak
                        },
                        data: results.data
                    });
                }
            })
        });
    }
    static parse(file) {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsText(file);
        });
    }
    static parameters(props) {
        return <Fragment>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Elválasztó karakter"
                        name="delimiter"
                        value={escape(props.value?.delimiter || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <Select
                        storeType="local"
                        labelKey="label"
                        valueKey="value"
                        disabled={true}
                        options={["\\n","\\r","\\r\\n"].map((k) => ({value: k, label: k}))}
                        label="Sortörés"
                        name="linebreak"
                        objectValue={false}
                        value={escape(props.value?.linebreak || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Oszlop elválasztó karakter"
                        name="enclosure"
                        value={escape(props.value?.enclosure || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <TextInput
                        label="Elválasztó karakter"
                        name="escape"
                        value={escape(props.value?.escape || '')}
                        saveChanges={(field, value) => props.saveChanges(field, unescape(value))}
                    />
                </div>
            </div>
        </Fragment>
    }
}

class Xls {
    static build(data, _import) {
        return new Promise(resolve => {
            let workbook = XLSX.read(data, {
                type: 'binary'
            });

            let defaultSheet = null;
            if (workbook?.Workbook?.WBView?.[0]?.activeTab) {
                defaultSheet = workbook.Workbook.WBView[0].activeTab;
            }

            let sheet = _import?.config?.sheet || defaultSheet || 0;

            function getArrayOfArrayByRange(sheet, rawRange = null) {
                rawRange = rawRange || sheet['!ref'];
                if (!rawRange) {
                    return [];
                }
                let arrOfArr = [];
                let range = XLSX.utils.decode_range(rawRange);
                for (let row = 0/*range.s.r*/; row <= range.e.r; row += 1) {
                    let rowArr = []
                    for (let col = 0/*range.s.c*/; col <= range.e.c; col += 1) {
                        let addr = XLSX.utils.encode_cell({ c: col, r: row});
                        let value = sheet[addr] && sheet[addr].v;    // sheet[addr] may be undefined
                        rowArr.push(value);
                    }
                    arrOfArr.push(rowArr);
                }
                return arrOfArr;
            }

            //workbook.SheetNames.forEach(function(sheet) {
            resolve({
                meta: {
                    sheets: workbook.SheetNames,
                    sheet
                },
                data: getArrayOfArrayByRange(workbook.Sheets[workbook.SheetNames[sheet]])
            });
            //})
        });
    }
    static parse(file) {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.onload = result => {
                resolve(result.target.result);
            };
            reader.readAsBinaryString(file);
        });
    }
    static parameters(props) {
        let config = props?.import?.config;
        let activeSheet = config?.sheet;
        if (activeSheet === undefined || activeSheet === null) return null;
        return <Fragment>
            <div className="col-md-12">
                <div className="form-group">
                    <Tabs
                        className="no-margin"
                        currentTab={activeSheet}
                        defaultTab={config?.sheets?.[0]}
                        onTabChange={(sheet) => props.saveChanges("sheet", sheet)}
                    >
                        {config?.sheets?.map((sheet, idx) => {
                            return <TabContent
                                tabLabel={sheet}
                                tabName={idx}
                            />
                        })}
                    </Tabs>
                </div>
            </div>
        </Fragment>
    }
}

const getProcessor = (filetype) => {
    switch (filetype) {
        case "txt":
            return TXT;
        case "csv":
            return CSV;
        case "xls":
        case "xlsx":
            return Xls;
    }
}

const escape = (str) => str.replace(/\v/,"\\v").replace(/\f/,"\\f").replace(/\b/,"\\b").replace(/\n/,"\\n").replace(/\r/,"\\r").replace(/\t/,"\\t");
const unescape = (str) => str.replace(/\\v/, "\v").replace(/\\f/, "\f").replace(/\\b/, "\b").replace(/\\n/, "\n").replace(/\\r/,"\r").replace(/\\t/,"\t");

type FilterListerState = {
    opened?: boolean,
    parsedData?: any[],
    import?: object,
    importers?: [],
    loading?: boolean,
}

export default class Import extends React.Component<GUIProps, FilterListerState> {

    state = {
        opened: false,
        parsedData: null,
        import: null,
        importers: [],
        loading: false
    }

    constructor(props) {
        super(props);
        this.loadImporters();
    }

    loadImporters = () => {
        this.loadImportersRequest && this.loadImportersRequest.abort();
        if (!this.props?.componentConfig?.componentname) return;
        this.loadImportersRequest = postData({
            action: this.props.componentConfig.componentname + ".getImporters",
            listfield: this.props.request.listfield,
            [this.props.componentConfig.idfield]: this.props.request.parentid,
        });
        this.loadImportersRequest.then((resp) => {
            let importers = resp?.importers || [];
            let customImporters = [];
            if (this.props.customImporters instanceof Function) {
                customImporters = this.props.customImporters(this.props);
            }
            importers = [...importers, ...(customImporters || [])];
            this.setState({
                importers,
                import: importers[0] || null
            });
        })
    }

    build = () => {
        let Processor = getProcessor(this.state.import?.type);
        if (Processor) {
            Processor.build(this.state.import?.data, this.state.import).then(results => {
                this.setState({
                    parsedData: results.data,
                    import: {
                        ...(this.state.import || {}),
                        config: {
                            ...(this.state.import?.config || {}),
                            ...results.meta
                        }
                    }
                });
            });
        } else {
            this.setState({
                opened: false,
                parsedData: null,
            });
        }
    }

    saveImportConfig = (field, value) => {
        const config = {...(this.state.import?.config || {})};
        set(config, field, value);
        this.setState({import: {...(this.state.import || {}), config}});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            !isEqual(this.props.componentConfig, prevProps.componentConfig)
            ||
            (!prevProps.opened && !!this.props.opened)
            ||
            !isEqual(this.props?.request, prevProps?.request)
        ) {
            this.setState({importers: []});
            this.loadImporters();
        }
        if (!isEqual(this.state.import, prevState.import)) {
            this.build();
        }
    }

    componentWillUnmount() {
        this.loadImportersRequest && this.loadImportersRequest.abort();
    }

    render() {
        const config = this.state.import?.config || {};
        const selectedColumns = config?.fields || {};
        const requiredColumns = Object.entries(selectedColumns).filter(([column, settings]) => settings.required && (settings.column === null || settings.column === undefined)).map(([column, settings]) => column);
        const columnOptions = Object.entries(selectedColumns).reduce((all, [column, settings]) => ([...all, {...settings, id: column, label: column}]), []);
        let maxLength = 0;
        let data = [...(this.state.parsedData || [])].map((rowData) => {
            maxLength = rowData.length > maxLength ? rowData.length : maxLength;
            let row = {};
            let col = '';
            rowData.map((data) => {
                row[col = nextCol(col)] = data;
            });
            return row;
        });
        let col = '';
        const columns = [...Array(maxLength).keys()].map((key) => col = nextCol(col));
        const Parameters = getProcessor(this.state.import?.type)?.parameters;
        let body = null;
        if (!this.state.loading) {
            body = <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <Select
                            label="Importok"
                            storeType="local"
                            options={this.state.importers}
                            valueKey="id"
                            labelKey="label"
                            value={this.state.import}
                            saveChanges={(field, value) => {
                                this.setState({
                                    import: value
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <ImportButton
                            label="Lista fájl"
                            name="file"
                            saveChanges={(field, file) => {
                                let filetype = (file?.name || "").split(".").pop().toLowerCase();
                                const Processor = getProcessor(filetype);
                                if (Processor) {
                                    Processor.parse(file).then((result) => {
                                        this.setState({
                                            import: {
                                                ...(this.state.import || {}),
                                                type: filetype,
                                                data: result,
                                                file: file,
                                            }
                                        });
                                    });
                                } else {
                                    this.setState({
                                        import: {
                                            ...(this.state.import || {}),
                                            type: undefined,
                                            data: undefined,
                                            file: undefined,
                                        }
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
                {this.state.parsedData !== null &&
                <div className="col-md-12 excel-style">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                {requiredColumns.length ? <span className="label label-danger">{requiredColumns.join(", ")} megadása kötelező!</span> : null}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <DataGridInternal
                                    className="p-small-table"
                                    value={data}
                                    rowClassName={(props) => {
                                        const start = (props.data.navigation.rangestart || 0);
                                        return {
                                            "selected-row": props.rowIdx > Math.max((config?.firstRowIsAHead || 0) - start, -1),
                                            "first-selected-row": props.rowIdx == Math.max((config?.firstRowIsAHead || 0) - start + 1, 0),
                                            "last-selected-row": props.rowIdx == props.items.length - 1
                                        }
                                    }}
                                    fields={columns.reduce((all, column, idx) => {
                                        const has = Object.entries(selectedColumns).find(([_column, settings]) => idx + "" === "" + settings?.column);
                                        const selectedColumnName = has?.[0];
                                        const selected = has?.[1];
                                        return {
                                            ...all,
                                            [column]: {
                                                props: {
                                                    style: {
                                                        //fontWeight: selected ? "bold" : null,
                                                        //backgroundColor: selected ? "rgba(0,255,0,.2)" : null,
                                                    },
                                                    className: selected ? "selected-column" : null,
                                                    field: column,
                                                    actions: <Select
                                                        storeType="local"
                                                        isClearable={true}
                                                        options={columnOptions}
                                                        valueKey="id"
                                                        labelKey="label"
                                                        optionsTemplate={(option) => {
                                                            return <Fragment>{option.label}{option.required ?
                                                                <Fragment> <span
                                                                    className="invalid-feedback">*</span></Fragment> : null}</Fragment>
                                                        }}
                                                        value={selected ? selectedColumnName : null}
                                                        label={false}
                                                        objectValue={false}
                                                        name={column}
                                                        required={selected?.required}
                                                        saveChanges={(field, value) => {
                                                            let newFields = {...selectedColumns};
                                                            if (selected) {
                                                                newFields[selectedColumnName] = {
                                                                    ...(selectedColumns[selectedColumnName] || {}),
                                                                    column: null
                                                                };
                                                            }
                                                            if (value !== null) {
                                                                newFields[value] = {
                                                                    ...(selectedColumns[value] || {}),
                                                                    column: idx
                                                                };
                                                            }
                                                            this.saveImportConfig("fields", newFields);
                                                        }}
                                                    />,
                                                    header: column,
                                                    sortable: false,
                                                    filterable: false,
                                                }
                                            }
                                        }
                                    }, {})}
                                />
                            </div>
                        </div>
                        {Parameters && <Parameters
                            {...this.props}
                            import={this.state.import}
                            saveChanges={this.saveImportConfig}
                        />}
                        <div className="col-md-12">
                            <div className="form-group">
                                <TextInput
                                    type="number"
                                    label="Fejléc sorok száma"
                                    name="firstRowIsAHead"
                                    value={config.firstRowIsAHead}
                                    saveChanges={(field, value) => this.saveImportConfig(field, value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>;
        } else {
            body = <ContentLoader />;
        }
        return (
            <Fragment>
                <Confirm
                    size="large"
                    header="Import"
                    body={body}
                    acceptAble={!requiredColumns.length && !!this.state?.import?.file}
                    onAccept={async () => {
                        this.setState({loading: true});
                        try {
                            let params = {...this.state.import};
                            const args = {
                                action: this.props.componentConfig.componentname + (this.props.request.listfield ? ".importList" : ".importComponents"),
                                listfield: this.props.request.listfield,
                                [this.props.componentConfig.idfield]: this.props.request.parentid,
                                file: params.file,
                                importer_id: params.importer_id,
                                importerconfig_id: params.importerconfig_id,
                            };
                            let response;
                            if (params.callback) {
                                args.config = JSON.parse(JSON.stringify(params.config));
                                response = await params.callback(args);
                            } else {
                                args.config = JSON.stringify(params.config);
                                response = await fileUpload(args);
                            }
                            if (this.props.onImportCompleted) {
                                this.props.onImportCompleted(response);
                            }
                            if (this.props.onActionPerformed) {
                                this.props.onActionPerformed(response);
                            }
                        } catch (e) {
                            console.error(e);
                        } finally {
                            this.setState({loading: false});
                        }
                    }}
                    acceptButton="Importálás"
                >
                    <this.props.actionButton>
                        <span className="nowrap"><Icon lib="far" name="file-excel" /> Import</span>
                    </this.props.actionButton>
                </Confirm>
            </Fragment>
        );
    }
}